module.exports = __webpack_public_path__ + "img/sl_slider11.9b37127e.png";